import "../components/store/store.scss";
import React from "react";
import { Row, Col, Card, CardHeader, CardTitle, CardBody, CardFooter, Button } from "reactstrap";
import { toast } from "react-toastify";

import CameraModelCapabilities from "../components/cameraModel/CameraModelCapabilities";
import { getStoreByLocation } from "../services/storeService";
import setDocumentTitle from "../components/shared/utils/documentTitle";

class StoreCapabilitiesView extends React.Component {
  // Identifies the current navigation; a response from an older one is dropped.
  navEpoch = 0;

  unmounted = false;

  state = {
    storeLocation: null,
    storeId: null,
    localInference: false,
  };

  componentDidMount() {
    const { match } = this.props;
    this.loadStore(match.params.location);
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (prevProps.match.params.location !== match.params.location) {
      this.loadStore(match.params.location);
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  loadStore = async (storeLocation) => {
    this.navEpoch += 1;
    const epoch = this.navEpoch;
    let storeId = null;
    let localInference = false;
    let failed = false;
    try {
      const response = await getStoreByLocation(storeLocation);
      storeId = response.data.id;
      localInference = !!response.data.local_inference;
    } catch (ex) {
      failed = true;
    }
    if (epoch !== this.navEpoch || this.unmounted) {
      return;
    }
    if (failed) {
      toast.error("Unable to fetch store details");
    }
    setDocumentTitle(`${storeLocation} capabilities`);
    this.setState({ storeLocation, storeId, localInference });
  };

  render() {
    const { storeLocation, storeId, localInference } = this.state;
    return (
      <div className="content">
        <Row>
          <Col md="12">
            {storeLocation && (
              <Card className="store-config">
                <CardHeader className="mb-2">
                  <h5 className="card-category">Store Capabilities</h5>
                  <CardTitle tag="h2">
                    {storeLocation}
                    <a className="ml-3" href={storeId ? `/stores/${storeId}` : "#"}>
                      <Button disabled={!storeId}>Store config</Button>
                    </a>
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  {storeId != null && <CameraModelCapabilities storeId={storeId} localInference={localInference} />}
                </CardBody>
                <CardFooter />
              </Card>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default StoreCapabilitiesView;
